import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthenticatedGuard } from '../../misc/guards/authenticated.guard';
import { CameraPageComponent } from './camera.page';

const routes: Routes = [
  {
    canActivate: [AuthenticatedGuard],
    component: CameraPageComponent,
    path: ''
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)]
})
export class CameraPageRoutingModule {}
